import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.primary.alt,
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    width: "519px",
    height: "600px",
  },
  header: {
    color: theme.palette.primary.contrastText,
    fontWeight: "bold",
    fontSize: 36,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: "solid white",
  },
  addButton: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    marginTop: theme.spacing(2),
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  addIcon: {
    height: "2rem",
    width: "2rem",
  },
  addButtonText: {
    paddingLeft: theme.spacing(2),
    fontSize: 24,
  },
}));

export default useStyles;
